import classnames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'
import { SignupButtons } from 'src/components/page/layout/footer/signup/signup-buttons'
import { useSecurityContext } from 'src/contexts/security.context'

import * as styles from './signup-banner.module.scss'

export interface SignupProps {
  sticky?: boolean
  trackPosition?: (position: number) => void
  hidePosition?: number
}

const getOffsetTop = (elem: any): number => {
  let offsetLeft = 0
  do {
    if (!isNaN(elem?.offsetTop as number)) {
      offsetLeft += elem?.offsetTop as number
    }
  } while ((elem = elem?.offsetParent))
  return offsetLeft
}

export const SignupCTA: React.FC<SignupProps> = ({
  sticky = false,
  trackPosition,
  hidePosition,
}) => {
  const { security } = useSecurityContext()
  const [hidden, setHidden] = useState(false)

  const handleScroll = () => {
    if (!!hidePosition) {
      if (window.pageYOffset >= hidePosition - window.innerHeight) {
        if (!hidden) {
          setHidden(true)
        }
      } else {
        if (hidden) {
          setHidden(false)
        }
      }
    }
  }

  useEffect(() => {
    if (sticky) {
      window.addEventListener('scroll', handleScroll)

      return () => window.removeEventListener('scroll', handleScroll)
    }
  })

  useEffect(() => {
    if (trackPosition) {
      trackPosition(getOffsetTop(signupRef.current))
    }
  }, [])

  const signupRef = useRef<HTMLDivElement | null>(null)

  return (
    <div
      ref={signupRef}
      className={classnames(styles.signupBanner, {
        [styles.signupBannerSticky]: sticky,
        [styles.signupBannerHidden]: hidden,
      })}
    >
      <h2 className={styles.signupBanner__heading}>
        Discover the metrics influencing {security.name}'s share price
      </h2>

      <SignupButtons />
    </div>
  )
}

export default SignupCTA
